module.exports = __webpack_public_path__ + "img/DCA Bot.64eca6de.svg";